import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const DiggingLoadingSummaryTableNoResultsContent = () =>
  <div className="text-center flex flex-col gap-1 py-4">
    <span className="text-sm text-theme-text">No digging entries during selected shift.</span>
    <div className="flex flex-col items-center justify-center gap-6">
      <div className="h-[2px] w-[15rem] bg-theme-table-border" />
      <p className="text-base text-theme-text max-w-[45rem]">
        You can manage digging entries on the
        <Link
          className="mx-1 inline-flex items-center gap-1 px-2 font-bold border border-theme-info bg-theme-surface-2 hover:bg-theme-info-hover hover:text-white rounded transition duration-150 ease-in-out text-theme-info"
          to='/production/show'>
          Production
          <FontAwesomeIcon className="text-xs" icon={faExternalLinkAlt} />
        </Link>
        page.
      </p>
    </div>
  </div>

export default DiggingLoadingSummaryTableNoResultsContent;